import React, { useState } from 'react';
import { FaUserPlus, FaEdit, FaTrash, FaUserTie, FaUser, FaUsers, FaUserCog } from 'react-icons/fa';

const GrampanchayatPadadhikari = () => {
  const [activeTab, setActiveTab] = useState('sarpanch');
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  
  // Mock Data State
  const [data, setData] = useState({
    sarpanch: [],
    upsarpanch: [],
    member: [],
    gramsevak: []
  });

  // Form State
  const [formData, setFormData] = useState({});

  const tabs = [
    { id: 'sarpanch', label: 'सरपंच', icon: <FaUserTie /> },
    { id: 'upsarpanch', label: 'उपसरपंच', icon: <FaUser /> },
    { id: 'member', label: 'सदस्य', icon: <FaUsers /> },
    { id: 'gramsevak', label: 'ग्रामसेवक / कर्मचारी', icon: <FaUserCog /> },
  ];

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newData = { ...formData, id: Date.now() };
    
    if (editingId) {
      setData({
        ...data,
        [activeTab]: data[activeTab].map(item => item.id === editingId ? { ...formData, id: editingId } : item)
      });
    } else {
      setData({
        ...data,
        [activeTab]: [...data[activeTab], newData]
      });
    }
    
    setShowForm(false);
    setFormData({});
    setEditingId(null);
  };

  const handleEdit = (item) => {
    setFormData(item);
    setEditingId(item.id);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('तुम्हाला खात्री आहे की तुम्ही हे रेकॉर्ड हटवू इच्छिता?')) {
      setData({
        ...data,
        [activeTab]: data[activeTab].filter(item => item.id !== id)
      });
    }
  };

  const renderForm = () => {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl overflow-hidden animate-fade-in-up">
          <div className="bg-[#267c77] p-4 text-white flex justify-between items-center">
            <h3 className="text-xl font-bold">
              {editingId ? 'माहिती अपडेट करा' : 'नवीन माहिती जोडा'} - {tabs.find(t => t.id === activeTab)?.label}
            </h3>
            <button onClick={() => setShowForm(false)} className="text-white hover:text-gray-200">
              ✖
            </button>
          </div>
          
          <form onSubmit={handleSubmit} className="p-6 space-y-4 max-h-[80vh] overflow-y-auto">
            {/* Common Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">पूर्ण नाव</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">मोबाईल नंबर</label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                  required
                />
              </div>
            </div>

            {/* Role Specific Fields */}
            {activeTab === 'sarpanch' && (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">पत्ता</label>
                    <textarea
                      name="address"
                      value={formData.address || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">आधार नंबर</label>
                    <input
                      type="text"
                      name="aadhar"
                      value={formData.aadhar || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">कार्यकाल सुरू तारीख</label>
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">कार्यकाल समाप्त तारीख</label>
                    <input
                      type="date"
                      name="endDate"
                      value={formData.endDate || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                </div>
              </>
            )}

            {activeTab === 'upsarpanch' && (
              <>
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">पत्ता</label>
                    <textarea
                      name="address"
                      value={formData.address || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">रुजू झाल्याची तारीख</label>
                    <input
                      type="date"
                      name="joiningDate"
                      value={formData.joiningDate || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                </div>
              </>
            )}

            {activeTab === 'member' && (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">वॉर्ड नंबर</label>
                    <input
                      type="text"
                      name="wardNo"
                      value={formData.wardNo || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                   <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">लिंग (Gender)</label>
                    <select
                      name="gender"
                      value={formData.gender || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    >
                      <option value="">निवडा</option>
                      <option value="Male">पुरुष</option>
                      <option value="Female">स्त्री</option>
                      <option value="Other">इतर</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">प्रवर्ग (Category)</label>
                    <select
                      name="category"
                      value={formData.category || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    >
                      <option value="">निवडा</option>
                      <option value="General">General</option>
                      <option value="OBC">OBC</option>
                      <option value="SC">SC</option>
                      <option value="ST">ST</option>
                       <option value="VJNT">VJNT</option>
                    </select>
                  </div>
                </div>
              </>
            )}

            {activeTab === 'gramsevak' && (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">पद</label>
                    <input
                      type="text"
                      name="designation"
                      value={formData.designation || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                   <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">रुजू झाल्याची तारीख</label>
                    <input
                      type="date"
                      name="joiningDate"
                      value={formData.joiningDate || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">वेतन माहिती (Optional)</label>
                    <input
                      type="text"
                      name="salaryInfo"
                      value={formData.salaryInfo || ''}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
                    />
                  </div>
                </div>
              </>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">फोटो अपलोड</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleInputChange}
                className="w-full p-2 border rounded focus:ring-[#267c77] focus:border-[#267c77]"
              />
            </div>

            <div className="flex justify-end space-x-3 pt-4 border-t">
              <button
                type="button"
                onClick={() => setShowForm(false)}
                className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
              >
                रद्द करा
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e635f]"
              >
                सेव्ह करा
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      {/* Tabs */}
      <div className="flex flex-wrap border-b">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center space-x-2 px-6 py-4 text-sm font-medium transition-colors duration-200 ${
              activeTab === tab.id
                ? 'border-b-2 border-[#267c77] text-[#267c77] bg-teal-50'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-800">
            {tabs.find(t => t.id === activeTab)?.label} माहिती
          </h2>
          <button
            onClick={() => {
              setFormData({});
              setEditingId(null);
              setShowForm(true);
            }}
            className="flex items-center space-x-2 bg-[#267c77] text-white px-4 py-2 rounded-lg hover:bg-[#1e635f] transition-colors"
          >
            <FaUserPlus />
            <span>नवीन जोडा</span>
          </button>
        </div>

        {data[activeTab].length === 0 ? (
          <div className="text-center py-10 bg-gray-50 rounded-lg border border-dashed border-gray-300">
            <p className="text-gray-500">कोणतीही माहिती उपलब्ध नाही. नवीन माहिती जोडण्यासाठी बटणावर क्लिक करा.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data[activeTab].map((item) => (
              <div key={item.id} className="bg-white border rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden group">
                <div className="h-2 bg-[#267c77]"></div>
                <div className="p-5">
                  <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-12 h-12 bg-gray-200 rounded-full overflow-hidden flex items-center justify-center">
                        {item.photo ? (
                           <span className="text-xs text-center text-gray-500">Img</span> // Placeholder for file logic
                        ) : (
                          <FaUser className="text-gray-400 text-xl" />
                        )}
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-900">{item.fullName}</h3>
                        <p className="text-sm text-gray-500">{item.mobile}</p>
                      </div>
                    </div>
                    <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button onClick={() => handleEdit(item)} className="text-blue-600 hover:bg-blue-50 p-1.5 rounded">
                        <FaEdit />
                      </button>
                      <button onClick={() => handleDelete(item.id)} className="text-red-600 hover:bg-red-50 p-1.5 rounded">
                        <FaTrash />
                      </button>
                    </div>
                  </div>
                  
                  <div className="mt-4 space-y-2 text-sm text-gray-600 bg-gray-50 p-3 rounded-lg">
                    {activeTab === 'sarpanch' && (
                      <>
                        <p><span className="font-medium">कार्यकाल:</span> {item.startDate} ते {item.endDate}</p>
                        <p><span className="font-medium">आधार:</span> {item.aadhar}</p>
                      </>
                    )}
                    {activeTab === 'upsarpanch' && (
                       <p><span className="font-medium">रुजू दिनांक:</span> {item.joiningDate}</p>
                    )}
                    {activeTab === 'member' && (
                      <>
                        <p><span className="font-medium">वॉर्ड:</span> {item.wardNo}</p>
                         <p><span className="font-medium">लिंग:</span> {item.gender} | <span className="font-medium">प्रवर्ग:</span> {item.category}</p>
                      </>
                    )}
                     {activeTab === 'gramsevak' && (
                      <>
                        <p><span className="font-medium">पद:</span> {item.designation}</p>
                         <p><span className="font-medium">रुजू दिनांक:</span> {item.joiningDate}</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showForm && renderForm()}
    </div>
  );
};

export default GrampanchayatPadadhikari;
